/**
 * Service-worker tile cache helpers.
 * SW lives at /sw.js and is registered on app boot.
 */

let registered = false;

export function registerTileCacheSW(): void {
  if (registered) return;
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;
  registered = true;
  // Register asynchronously — never block app paint.
  navigator.serviceWorker
    .register('/sw.js', { scope: '/' })
    .catch((err) => {
      // eslint-disable-next-line no-console
      console.warn('tile cache SW register failed:', err);
    });
}

/** Ask the SW how big the tile cache is. Falls back to 0 if SW not active. */
export async function getTileCacheBytes(): Promise<number> {
  return msg<{ type: 'tile-cache-size'; bytes: number }>('tile-cache-size').then(
    (m) => (m?.bytes ?? 0),
  );
}

/** Wipe the tile cache. Resolves once the SW confirms. */
export async function clearTileCache(): Promise<void> {
  await msg<{ type: 'tile-cache-cleared' }>('clear-tile-cache');
}

function msg<T extends { type: string }>(type: string): Promise<T | null> {
  return new Promise((resolve) => {
    if (typeof navigator === 'undefined' || !navigator.serviceWorker?.controller) {
      resolve(null);
      return;
    }
    const channel = new MessageChannel();
    const timeout = window.setTimeout(() => resolve(null), 2000);
    channel.port1.onmessage = (event) => {
      window.clearTimeout(timeout);
      resolve(event.data as T);
    };
    navigator.serviceWorker.controller.postMessage({ type }, [channel.port2]);
  });
}

export function fmtBytes(n: number): string {
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  if (n < 1024 * 1024 * 1024) return `${(n / 1024 / 1024).toFixed(1)} MB`;
  return `${(n / 1024 / 1024 / 1024).toFixed(2)} GB`;
}
